var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reputation d-flex align-items-center"},[_vm._l((_vm.getReputationIcons()),function(icon,index){return _c('i',{key:index,class:icon})}),_c('span',{staticClass:"comments"},[_vm._v("\n     ("+_vm._s(_vm.reviews)+" "),_c('i',{staticClass:"fa-regular fa-comment"}),_vm._v(")\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }